import React, { useEffect } from 'react';
import './about.css'; // Custom styles for the About component
import AOS from 'aos'; // Import AOS library
import 'aos/dist/aos.css'; // Import AOS styles

const About = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true }); // Initialize AOS with configuration
  }, []);

  return (
    <section id="about" className="about section">
      <div className="container">
        <div className="row gy-4">


          {/* Content Section */}
          <div
            className="col-lg-6 content"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            <h3>About Us</h3>
            <h5>Welcome to Gantasoft - A Top Web Development Company in India</h5>
            <p>
              We are a trusted and fully registered company in India, offering top-notch web development and design services. Specializing in creating multi-functional web portals, we ensure that every website we develop is visually appealing and optimized for delivering ROI-driven outcomes. Our professional approach guarantees innovative solutions tailored to meet our clients' business needs and goals.
            </p>
            <ul>
              <li>
                <i className="bi bi-diagram-3"></i>
                <div>
                  <h5>Affordable Website Solutions</h5>
                  <p>
                    We focus on providing top-notch, tailor-made websites at an affordable price, ensuring a professional online presence is within everyone's reach.
                  </p>
                </div>
              </li>
              <li>
                <i className="bi bi-fullscreen-exit"></i>
                <div>
                  <h5>Expert Software Development</h5>
                  <p>
                    Our team of skilled developers delivers innovative software solutions customized to address the specific requirements of each client.
                  </p>
                </div>
              </li>
              <li>
                <i className="bi bi-broadcast"></i>
                <div>
                  <h5>Customer-Centric Approach</h5>
                  <p>
                    Our focus is on building lasting partnerships by offering reliable, efficient, and user-friendly services that help businesses grow.
                  </p>
                </div>
              </li>
            </ul>
          </div>
          {/* Image Section */}
          <div
            className="col-lg-6 position-relative order-lg-first"
            data-aos="fade-up"
            data-aos-delay="200"
          >
                 <img
              src="assets/img/about/image1.png"
              className="img-fluid image-ratio"
              alt="About Us"
            />
            {/* <img
              src="assets/img/about.jpg"
              className="img-fluid"
              alt="About Us"
            /> */}
            {/* <a
              href="https://www.youtube.com/watch?v=Y7f98aduVJ8"
              className="glightbox pulsating-play-btn"
            ></a> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
